import { useTranslation } from "react-i18next";

/**
 * Get invoice type based on need
 * @param {String} need financial need
 * @returns {Object} { label: "", value: "" }
 */
export default function useInvoiceType(need) {
  const { t } = useTranslation(["common"]);

  const clientInvoiceType = { label: t("common:client"), value: "client" };
  const supplierInvoiceType = {
    label: t("common:supplier"),
    value: "supplier",
  };

  const needToInvoiceType = {
    clients: clientInvoiceType,
    stock: supplierInvoiceType,
    vendors: supplierInvoiceType,
  };

  return needToInvoiceType[need];
}
